import { AuthorizationService } from "@services/authorization.service";
import { IStateData } from "@services/routeConfigHelper.provider";
import { StateRegistry } from "@uirouter/angularjs";
import { StateService } from "@uirouter/core";
import "./routeTabs.component.scss";

interface IRouteTab {

    tabTitle: string;
    routeName: string;
    icon: string;
    selected?: boolean;
    count: number | string;
    location: string;
}

class Controller implements angular.IComponentController/*, IRegisterTab */ {
    route: string;
    routeTabs: IRouteTab[] = [];
    counts: { [key: string]: number | string }

    static $inject = ["$state", "$stateRegistry", "authorizationService"];

    constructor(
        private readonly $state: StateService,
        private readonly $stateRegistry: StateRegistry,
        private readonly authorizationService: AuthorizationService) {
    }

    $onInit() {
        // Find all child states
        var parentState = this.route || this.$state.$current.name;
        //var stateTokens = parentState.split(".");
        //parentState = stateTokens.slice(0, -1).join(".");

        var children = this.$stateRegistry.get().filter((cState) => { return cState.name.indexOf(parentState) === 0 && cState.name != parentState });

        children.forEach(childState => {

            if (childState.abstract) {
                return;
            }

            var data: IStateData = childState.data;
            if (!data?.translation) {
                return;
            }

            if (data?.roles || data?.features) {
                if (!this.authorizationService.isUserAuthorized(data.roles, data.features)) {
                    return;
                }
            }

            this.routeTabs.push({
                tabTitle: data.translation,
                routeName: childState.name,
                icon: data.icon,
                count: this.counts && this.counts[data.countKey],
                location: data.location,
                selected: this.$state.$current.name == childState.name
            });
        });

        // Auto select first, if we have none
        if (!this.routeTabs.some(t => t.selected)) {
            this.routeTabs[0].selected = true;
        }
    }

    tabSelected(tab: IRouteTab) {
        // Dont recurse
        if (this.$state.$current.name == tab.routeName) {
            return;
        }

        this.$state.go(tab.routeName);
    }
}

export class VeriRouteTabsComponent implements angular.IComponentOptions {
    bindings: any;
    require: { [index: string]: string; };
    controller: any;
    template: string | angular.Injectable<(...args: any[]) => string>;

    constructor() {
        this.bindings = {
            route: "@",
            counts: "<"
        };

        this.controller = Controller;
        this.template = require("./routeTabs.component.html");
    }
}
